import React, { useEffect, useState } from 'react';
import RequestServices from '../helpers/requestServices';
import styles from './Status.module.scss';

import logoFPO from '../assets/img/hdProLogoVectorDark.svg';
import { Button, Dropdown, Menu, message, Modal, Tag } from 'antd';
import { CloseCircleOutlined, ExclamationCircleOutlined, LoginOutlined } from '@ant-design/icons';

const api = new RequestServices({});

export default function Status(props: any) {
  useEffect(() => {
    document.title = 'Update Status - HD Pro';
    getStatus();
  }, []);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    address: '',
    archived_count: 0,
    disabled_count: 0,
    front_image: '',
    in_progress_count: 0,
    listing_name: '',
    lsta_id: 0,
    mls_id: '',
    order_id: 0,
    order_type_name: '',
    publish_date: '',
  });
  const [textStatus, setTextStatus] = React.useState({ id: 0, name: '' });
  const [statusID, setStatusID] = React.useState([
    {
      lsta_id: 0,
      lsta_descr: 'Active',
    },
    {
      lsta_id: 5,
      lsta_descr: 'Pending',
    },
    {
      lsta_id: 12,
      lsta_descr: 'Off Market',
    },
    {
      lsta_id: 6,
      lsta_descr: 'Sold',
    },
  ]) as any;

  const [idLoading, setIDLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const uuid = props.match.params.uuid;

  const statusColor = (id: number) => {
    let color = '';
    switch (id) {
      case 0:
      case 15:
        color = 'blue';
        // setTextStatus("Active")
        break;
      case 5:
      case 11:
        // setTextStatus('Pending')
        color = 'orange';
        break;
      case 12:
        // setTextStatus('Off Market')
        color = '';
        break;
      case 6:
      case 13:
        // setTextStatus('Sold')
        color = 'red';
        break;
      case 10:
        color = 'green';
        break;
      default:
        break;
    }
    return color;
  };

  const changeStatus = async (value: number, uuid: string, name: string) => {
    try {
      setIDLoading(true);
      await api.setStatus(uuid, { lsta_id: value });
      setTextStatus({ name: name, id: value });
      setIDLoading(false);
      
    } catch (error) {
      setIDLoading(false);
      message.error('Error updating status');
    }
  };
  const getStatus = async () => {
    try {
      const response = await api.getStatus(uuid);
      //   const idResponse = await api.getListingStatus();
      setData(response.data.data);
      setTextStatus({ id: response.data.data.lsta_id, name: response.data.data.listing_name });
      setIsDisabled(response.data.data.is_disabled);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };

  const disableTour = async () => {
    try {
      await api.disableTour(uuid);
      setIsDisabled(true);
      message.success('Tour disabled successfully');
    } catch (error) {
      message.error('Error disabling tour');
    }
  };

  const confirm = () => {
    Modal.confirm({
      title: 'Disable this tour?',
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>
            Disable the tour if you no longer want it to be available to the public. You can
            re-enable the tour from the Orders page if needed.{' '}
          </p>
          <p>NOTE: Custom videos and Matterport scans are removed after approximately 30 days.</p>
        </div>
      ),
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        disableTour();
      },
    });
  };

  const menu = (
    <Menu
      onClick={({ item, key }: any) => {
        // setStatusID(+key);
        console.log('key', item);
        changeStatus(+key, uuid, item.props['data-name']);
      }}
    >
      {statusID.map((el) => {
        return (
          <Menu.Item key={el.lsta_id} data-name={el.lsta_descr}>
            <Tag color={statusColor(el.lsta_id)}>{el.lsta_descr}</Tag>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  if (loading) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Header}>
        <div className={styles.Logo}>
          <img src={logoFPO} alt="logo" />
        </div>
        <div className={styles.Phone}>
          <span>have a question?</span>
          <a href="tel:206-384-4400">206-384-4400</a>
        </div>
      </div>
      <div className={styles.Content}>
        <h1>Update Status</h1>
        <div className={styles.Card}>
          <div className={styles.CardBody}>
            <div className={styles.CardInfo}>
              <img src={data.front_image} alt="Front" />
              <div className={styles.CardDetails}>
                <span>
                  <Tag color={statusColor(textStatus.id)}>{textStatus.name}</Tag>
                </span>
                <span className={styles.CardAddress}>{data.address}</span>
                <span className={styles.CardMls}>{data.mls_id}</span>
              </div>
            </div>
            {isDisabled ? (
              <Tag
                className={styles.DisabledTag}
                icon={<CloseCircleOutlined />}
                color={''}
              >
                Disabled
              </Tag>
            ) : (
              <div className={styles.CardActions}>
                <Dropdown overlay={menu} placement="bottomLeft">
                  <Button loading={idLoading} type="default">
                    Update Listing Status
                  </Button>
                </Dropdown>
                <span style={{ opacity: 0.65, margin: '5px 0' }}>or</span>
                <Button style={{ width: '100%' }} onClick={confirm} danger={true} type="default">
                  Disable Tour
                </Button>
              </div>
            )}
          </div>
          <div className={styles.CardFooter}>
            <div style={{ opacity: 0.65 }}>{data.publish_date}</div>
            <div>
              <b>Order Type:</b> <span style={{ opacity: 0.65 }}>{data.order_type_name}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.Footer}>
        <span>Log in to manage properties & orders, or to download media. </span>
        <Button
          icon={<LoginOutlined />}
          style={{ width: '100%', marginTop: 20 }}
          type="primary"
          href={window.location.origin + '/signin'}
        >
          Manage All
        </Button>
      </div>
    </div>
  );
}
